/**
 * AI upload init for tinypresent theme — PDP, quick-add, validation, Shop Pay.
 */
(function () {
  "use strict";

  const UPLOADER_DEFAULTS = {
    jobNum: 1,
    pollInterval: 2000,
    maxPollAttempts: 60,
  };

  const SECTION_SELECTORS =
    ".ai-upload-section, #ai-upload-section, #ai-image-upload-section, .ai-image-upload-section";

  function waitForDeps(callback, attempts = 0) {
    if (
      typeof AiImageUploader !== "undefined" &&
      window.aiUploadModal &&
      window.AiProductMedia &&
      window.AiGenerationHistory
    ) {
      callback();
      return;
    }
    if (attempts > 80) {
      console.error("[AI Upload] Required AI upload modules not loaded");
      return;
    }
    setTimeout(() => waitForDeps(callback, attempts + 1), 100);
  }

  function getVariantMetafields(root) {
    const container =
      root.closest(
        ".product-information, .product-details, quick-add-dialog, .drawer__content"
      ) || root;
    const script =
      container.querySelector(".variant-metafields-data") ||
      document.querySelector(".variant-metafields-data");
    if (!script) return {};
    try {
      const data = JSON.parse(script.textContent);
      return data.variantMetafields || {};
    } catch {
      return {};
    }
  }

  function variantNeedsDualUpload(variantId, metafields) {
    const raw = metafields[variantId]?.isdouble;
    if (!raw) return false;
    const value =
      typeof raw === "object" && raw.value !== undefined ? raw.value : raw;
    const lower = String(value).toLowerCase();
    return lower === "yes" || lower === "true" || value === true;
  }

  function clearSecondUploader(root) {
    if (root._couplePendingFiles) {
      root._couplePendingFiles[2] = null;
    }

    const uploader2 = root._aiUploaders?.[2];
    if (uploader2?._localPreviewUrl) {
      URL.revokeObjectURL(uploader2._localPreviewUrl);
      uploader2._localPreviewUrl = null;
    }

    const hidden2 = root.querySelector("#ai-user-image-url-2");
    const trigger2 = root.querySelector("#ai-upload-trigger-2");
    const preview2 = root.querySelector("#ai-upload-preview-2");
    const status2 = root.querySelector("#ai-upload-status-2");
    const fileInput2 = root.querySelector("#ai-file-input-2");

    if (hidden2) hidden2.value = "";
    if (fileInput2) fileInput2.value = "";
    if (trigger2) {
      trigger2.classList.remove("has-image", "validation-error");
      delete trigger2.dataset.pendingPhoto;
    }
    if (preview2) {
      if (preview2.src?.startsWith("blob:")) {
        URL.revokeObjectURL(preview2.src);
      }
      preview2.src = "";
    }
    if (status2) {
      status2.textContent = "";
      status2.className = "ai-upload-status";
    }
  }

  function hasUploadPreview(preview, trigger) {
    return (
      trigger?.classList.contains("has-image") &&
      Boolean(preview?.getAttribute("src"))
    );
  }

  function setGeneratedPreview(preview, trigger, generatedUrl) {
    if (!preview || !trigger || !generatedUrl) return;

    preview.src = generatedUrl;
    trigger.classList.add("has-image");
    trigger.classList.remove("validation-error");
    delete trigger.dataset.pendingPhoto;
  }

  function toggleSecondUploader(root, show) {
    const container1 = root.querySelector(
      '.ai-upload-container[data-upload-index="1"]'
    );
    const container2 = root.querySelector(
      '.ai-upload-container[data-upload-index="2"]'
    );

    if (container1) {
      container1.style.display = "flex";
    }
    if (container2) {
      container2.style.display = show ? "flex" : "none";
    }

    root.dataset.coupleMode = show ? "true" : "false";

    if (!show) {
      clearSecondUploader(root);
    }
  }

  function getFormForRoot(root) {
    const sectionId = root.dataset.sectionId || root.dataset.formId;
    if (sectionId) {
      const bySection = document.getElementById(
        "BuyButtons-ProductForm-" + sectionId
      );
      if (bySection) return bySection;
    }

    const hidden = root.querySelector("#ai-custom-image-url");
    const linkedId = hidden?.getAttribute("form");
    if (linkedId) {
      const linked = document.getElementById(linkedId);
      if (linked) return linked;
    }

    return (
      root.closest('form[id*="ProductForm"]') ||
      root.closest("product-form-component, cm-product-form, quick-add-dialog")?.querySelector(
        'form[id*="ProductForm"]'
      )
    );
  }

  function bindRemoveButton(removeBtn, preview, trigger, hidden, status, root, index) {
    if (!removeBtn || removeBtn.dataset.bound === "true") return;
    removeBtn.dataset.bound = "true";
    removeBtn.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();

      const uploader = root?._aiUploaders?.[index];
      if (uploader?._localPreviewUrl) {
        URL.revokeObjectURL(uploader._localPreviewUrl);
        uploader._localPreviewUrl = null;
      }

      const fileInput = root.querySelector(
        index === 2 ? "#ai-file-input-2" : "#ai-file-input"
      );
      if (fileInput) fileInput.value = "";

      if (preview?.src?.startsWith("blob:")) {
        URL.revokeObjectURL(preview.src);
      }
      if (preview) preview.src = "";
      if (trigger) {
        trigger.classList.remove("has-image", "validation-error");
        delete trigger.dataset.pendingPhoto;
      }
      if (hidden) hidden.value = "";
      if (status) {
        status.textContent = "";
        status.className = "ai-upload-status";
      }
      if (root?._couplePendingFiles && index) {
        root._couplePendingFiles[index] = null;
      }
      const aiHidden = root.querySelector("#ai-custom-image-url");
      if (aiHidden) aiHidden.value = "";
      const taskHidden = root.querySelector("#ai-task-id");
      if (taskHidden) taskHidden.value = "";
    });
  }

  function applySelectedAiImage(root, url) {
    const aiHidden = root.querySelector("#ai-custom-image-url");
    const status1 = root.querySelector("#ai-upload-status");
    const status2 = root.querySelector("#ai-upload-status-2");
    const generateStatus = root.querySelector("#ai-generate-status");
    const generateTrigger = root.querySelector("#ai-generate-trigger");

    if (aiHidden) aiHidden.value = url;

    if (generateTrigger) {
      generateTrigger.classList.remove("validation-error");
    }

    [status1, status2, generateStatus].forEach((status) => {
      if (!status) return;
      status.textContent = "✓ Design selected!";
      status.className = "ai-upload-status success";
    });
  }

  function getTaskIdFromRoot(root) {
    return root.querySelector("#ai-task-id")?.value?.trim() || "";
  }

  function restoreTaskId(root, taskId) {
    const taskHidden = root.querySelector("#ai-task-id");
    if (taskHidden && taskId) {
      taskHidden.value = String(taskId);
    }
  }

  function getUserImageUrlsFromEntry(entry) {
    if (!entry || typeof entry !== "object") return [];

    const normalized = window.AiGenerationHistory?.normalizeEntry
      ? window.AiGenerationHistory.normalizeEntry(entry)
      : entry;

    if (!normalized) return [];

    const url1 = String(normalized.userImageUrl || "").trim();
    const url2 = String(normalized.userImageUrl2 || "").trim();
    return [url1, url2].filter(Boolean);
  }

  function buildHistorySaveContext(root, context) {
    const userImageUrls = getUserImageUrlsFromRoot(root);
    return {
      ...(context || {}),
      taskId: getTaskIdFromRoot(root),
      generationMode: root.dataset.generationMode || "photo",
      userImageUrl: userImageUrls[0] || "",
      userImageUrl2: userImageUrls[1] || "",
      userImageUrls,
    };
  }

  /**
   * Restore a history entry: custom fields, variant, generated image, taskId, user photos.
   *
   * @param {Element} root
   * @param {Record<string, unknown>} entry
   */
  async function restoreHistoryEntry(root, entry) {
    const normalized = window.AiGenerationHistory?.normalizeEntry
      ? window.AiGenerationHistory.normalizeEntry(entry)
      : entry;

    if (!normalized) return;

    if (typeof window.applyAiGenerationContext === "function") {
      await window.applyAiGenerationContext(root, normalized);
    }

    const generatedImageUrl =
      normalized.generatedImageUrl || normalized.url || "";
    if (generatedImageUrl) {
      applySelectedAiImage(root, generatedImageUrl);
    }

    if (normalized.taskId) {
      restoreTaskId(root, normalized.taskId);
    }

    const shouldRestoreUserImages =
      !isPropertiesOnlyMode(root) &&
      normalized.generationMode !== "properties_only";
    const userImageUrls = getUserImageUrlsFromEntry(normalized);

    if (shouldRestoreUserImages && userImageUrls.length) {
      restoreUserImageUrls(root, userImageUrls);
    }
  }

  function getHistoryEmptyMessage(root) {
    if (isPropertiesOnlyMode(root)) {
      return "No history yet. Your generated designs will be saved here after you generate a preview.";
    }
    return "No history yet. Your generated designs will be saved here after you upload a photo.";
  }

  function getUserImageUrlsFromRoot(root) {
    const url1 = root.querySelector("#ai-user-image-url")?.value?.trim() || "";
    const url2 =
      root.querySelector("#ai-user-image-url-2")?.value?.trim() || "";
    const urls = [url1, url2].filter(Boolean);
    return urls.length ? urls : [];
  }

  function restoreUserImageUrls(root, urls) {
    if (!root || !Array.isArray(urls) || !urls.length) return;

    const userHidden1 = root.querySelector("#ai-user-image-url");
    const userHidden2 = root.querySelector("#ai-user-image-url-2");
    const trigger1 = root.querySelector("#ai-upload-trigger");
    const trigger2 = root.querySelector("#ai-upload-trigger-2");
    const preview1 = root.querySelector("#ai-upload-preview");
    const preview2 = root.querySelector("#ai-upload-preview-2");

    if (urls[0] && userHidden1) userHidden1.value = urls[0];
    if (urls[1] && userHidden2) userHidden2.value = urls[1];

    if (root._couplePendingFiles) {
      root._couplePendingFiles = { 1: null, 2: null };
    }

    const applyPreview = (preview, trigger, url, uploader) => {
      if (!url) return;

      if (uploader?._localPreviewUrl) {
        URL.revokeObjectURL(uploader._localPreviewUrl);
        uploader._localPreviewUrl = null;
      }

      if (preview) {
        if (preview.src?.startsWith("blob:")) {
          URL.revokeObjectURL(preview.src);
        }
        preview.src = url;
      }

      if (trigger) {
        trigger.classList.add("has-image");
        trigger.classList.remove("validation-error");
        delete trigger.dataset.pendingPhoto;
      }
    };

    applyPreview(preview1, trigger1, urls[0], root._aiUploaders?.[1]);
    applyPreview(preview2, trigger2, urls[1], root._aiUploaders?.[2]);

    if (urls.length >= 2) {
      toggleSecondUploader(root, true);
    }
  }

  function syncAiImageToCarousel(root, url, { select = true } = {}) {
    if (!url || !window.AiProductMedia) {
      return Promise.resolve(null);
    }

    const append =
      window.AiProductMedia.addImageToProductMediaWhenReady ||
      window.AiProductMedia.addImageToProductMedia;

    return append.call(window.AiProductMedia, url, {
      select,
      root,
    });
  }

  function getActiveAiImageUrl(root) {
    const hidden = root.querySelector("#ai-custom-image-url");
    return hidden?.value?.trim() || null;
  }

  /**
   * Re-append AI preview to carousel after variant:update (DOM replaceWith).
   * Same-product JSON variant switches keep the gallery DOM, so this is skipped there.
   * Keep select=false so the gallery stays on the variant's main image.
   */
  function scheduleCarouselResyncAfterVariant(root) {
    if (root._aiVariantCarouselSyncTimer) {
      clearTimeout(root._aiVariantCarouselSyncTimer);
    }

    root._aiVariantCarouselSyncTimer = setTimeout(() => {
      root._aiVariantCarouselSyncTimer = null;

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          const url = getActiveAiImageUrl(root);
          if (!url) return;
          syncAiImageToCarousel(root, url, { select: false });
        });
      });
    }, 80);
  }

  function handleAiImageReady(
    root,
    url,
    { saveHistory = true, generationContext = null, scrollOnMobile = false } = {}
  ) {
    if (!url) return Promise.resolve(null);

    const productId = window.AiGenerationHistory.getProductIdFromSection(root);
    const context =
      generationContext ||
      (typeof window.getAiGenerationContext === "function"
        ? window.getAiGenerationContext(root)
        : null);

    if (saveHistory && productId) {
      window.AiGenerationHistory.add(url, productId, buildHistorySaveContext(root, context));
    }

    return syncAiImageToCarousel(root, url).then((result) => {
      if (scrollOnMobile) {
        scrollToProductMediaAfterConfirm(root);
      }
      return result;
    });
  }

  function scrollToProductMediaAfterConfirm(root) {
    if (!window.matchMedia("(max-width: 999px)").matches) return;

    const runScroll = () => {
      if (typeof window.AiProductMedia?.scrollToProductMedia === "function") {
        window.AiProductMedia.scrollToProductMedia(root);
      }
    };

    // Modal closes after confirm; delay so body scroll unlocks and carousel can select AI slide.
    setTimeout(() => {
      requestAnimationFrame(() => {
        requestAnimationFrame(runScroll);
      });
    }, 480);
  }

  function ensureHistoryModal() {
    let modal = document.getElementById("ai-generation-history-modal");
    if (modal) return modal;

    modal = document.createElement("div");
    modal.id = "ai-generation-history-modal";
    modal.className = "ai-history-modal";
    modal.hidden = true;
    modal.innerHTML = `
      <div class="ai-history-modal__backdrop" data-ai-history-close></div>
      <div class="ai-history-modal__dialog" role="dialog" aria-modal="true" aria-labelledby="ai-history-modal-title">
        <div class="ai-history-modal__header">
          <h2 id="ai-history-modal-title" class="ai-history-modal__title">Generation History</h2>
          <button type="button" class="ai-history-modal__close" data-ai-history-close aria-label="Close">&times;</button>
        </div>
        <div class="ai-history-modal__body">
          <div class="ai-history-modal__grid" data-ai-history-grid></div>
          <p class="ai-history-modal__empty" data-ai-history-empty hidden>No history yet. Your generated designs will be saved here after you upload a photo.</p>
        </div>
      </div>
    `;
    document.body.appendChild(modal);

    modal.addEventListener("click", (e) => {
      if (e.target.closest("[data-ai-history-close]")) {
        closeHistoryModal();
      }
    });

    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && !modal.hidden) {
        closeHistoryModal();
      }
    });

    return modal;
  }

  function closeHistoryModal() {
    const modal = document.getElementById("ai-generation-history-modal");
    if (modal) modal.hidden = true;
    document.body.classList.remove("ai-history-modal-open");
  }

  function openHistoryModal(root, uploadIndex) {
    const modal = ensureHistoryModal();
    const productId = window.AiGenerationHistory.getProductIdFromSection(root);
    const grid = modal.querySelector("[data-ai-history-grid]");
    const empty = modal.querySelector("[data-ai-history-empty]");
    const entries = productId
      ? window.AiGenerationHistory.getForProduct(productId)
      : [];

    modal.dataset.uploadIndex = String(uploadIndex);
    modal.dataset.sectionRoot = root.id || "ai-upload-section";

    if (!grid || !empty) return;

    if (empty) {
      empty.textContent = getHistoryEmptyMessage(root);
    }

    grid.innerHTML = "";

    if (!entries.length) {
      empty.hidden = false;
    } else {
      empty.hidden = true;
      entries.forEach((entry) => {
        const previewUrl = entry.generatedImageUrl || entry.url || "";
        const item = document.createElement("button");
        item.type = "button";
        item.className = "ai-history-modal__item";
        item.innerHTML = `<img src="${previewUrl}" alt="Generated design" loading="lazy" width="300" height="300" />`;
        item.addEventListener("click", async () => {
          await restoreHistoryEntry(root, entry);
          closeHistoryModal();

          const generatedImageUrl = entry.generatedImageUrl || entry.url || "";
          await handleAiImageReady(root, generatedImageUrl, {
            saveHistory: false,
            scrollOnMobile: true,
          });
        });
        grid.appendChild(item);
      });
    }

    modal.hidden = false;
    document.body.classList.add("ai-history-modal-open");
  }

  function bindHistoryTrigger(root) {
    const trigger = root.querySelector("[data-ai-history-trigger]");
    if (!trigger || trigger.dataset.bound === "true") return;
    trigger.dataset.bound = "true";

    trigger.addEventListener("click", () => {
      openHistoryModal(root, 1);
    });
  }

  function isPropertiesOnlyMode(root) {
    return (root.dataset.generationMode || "photo") === "properties_only";
  }

  function createPropertiesOnlyUploader(root) {
    const trigger = root.querySelector("#ai-generate-trigger");
    const status = root.querySelector("#ai-generate-status");

    if (!trigger || trigger.dataset.uploaderInitialized === "true") {
      return null;
    }

    const uploader = new AiImageUploader({
      ...UPLOADER_DEFAULTS,
      onImageGenerated: (url) => {
        handleAiImageReady(root, url);
      },
      onImageSelect: (url) => {
        applySelectedAiImage(root, url);
        handleAiImageReady(root, url, {
          saveHistory: true,
          scrollOnMobile: true,
        });
      },
      onUploadError: (error) => {
        if (status) {
          status.textContent =
            "✗ Generation failed: " + (error?.message || "Unknown error");
          status.className = "ai-upload-status error";
        }
      },
    });

    uploader.initPropertiesOnly(trigger);
    return uploader;
  }

  function createUploader(root, index) {
    const suffix = index === 2 ? "-2" : "";
    const trigger = root.querySelector(`#ai-upload-trigger${suffix}`);
    const input = root.querySelector(`#ai-file-input${suffix}`);
    const hidden = root.querySelector(
      index === 2 ? "#ai-user-image-url-2" : "#ai-user-image-url"
    );
    const preview = root.querySelector(`#ai-upload-preview${suffix}`);
    const status = root.querySelector(`#ai-upload-status${suffix}`);
    const removeBtn = root.querySelector(`#ai-upload-remove${suffix}`);

    if (!trigger || !input || !hidden || trigger.dataset.uploaderInitialized === "true") {
      return null;
    }

    trigger.dataset.uploaderInitialized = "true";

    const uploader = new AiImageUploader({
      ...UPLOADER_DEFAULTS,
      onUploadStart: (file) => {
        uploader.showLocalPhotoPreview(file);
      },
      onImageGenerated: (url) => {
        handleAiImageReady(root, url);
      },
      onImageSelect: (url) => {
        applySelectedAiImage(root, url);

        if (!hasUploadPreview(preview, trigger)) {
          setGeneratedPreview(preview, trigger, url);
        }

        handleAiImageReady(root, url, {
          saveHistory: true,
          scrollOnMobile: true,
        });
      },
      onUploadError: (error) => {
        if (status) {
          status.textContent =
            "✗ Upload failed: " + (error?.message || "Unknown error");
          status.className = "ai-upload-status error";
        }
      },
    });

    uploader.init(trigger, input, hidden);
    bindRemoveButton(removeBtn, preview, trigger, hidden, status, root, index);
    return uploader;
  }

  function validateCustomFields(root) {
    if (typeof window.ProductCustomFields?.validate !== "function") {
      return true;
    }

    const scope =
      root.closest(".product-information, .product-details, quick-add-dialog") ||
      root;
    const result = window.ProductCustomFields.validate(scope);

    if (result.valid) {
      return true;
    }

    const firstError = result.errors[0];
    firstError?.field?.scrollIntoView({ behavior: "smooth", block: "center" });

    if (firstError?.control instanceof HTMLElement) {
      if (typeof firstError.control.reportValidity === "function") {
        firstError.control.reportValidity();
      } else {
        firstError.control.focus({ preventScroll: true });
      }
    }

    return false;
  }

  function validateSection(root) {
    if (!validateCustomFields(root)) {
      return false;
    }

    const aiHidden = root.querySelector("#ai-custom-image-url");
    const hasAi = aiHidden && aiHidden.value.trim() !== "";

    if (isPropertiesOnlyMode(root)) {
      const generateTrigger = root.querySelector("#ai-generate-trigger");
      if (generateTrigger) {
        generateTrigger.classList.remove("validation-error");
      }

      if (!hasAi) {
        if (generateTrigger) {
          generateTrigger.classList.add("validation-error");
          generateTrigger.scrollIntoView({ behavior: "smooth", block: "center" });
        }
        return false;
      }

      return true;
    }

    if (root.dataset.requiresUpload !== "true") {
      return true;
    }

    const coupleMode = root.dataset.coupleMode === "true";
    const userHidden1 = root.querySelector("#ai-user-image-url");
    const userHidden2 = root.querySelector("#ai-user-image-url-2");
    const trigger1 = root.querySelector("#ai-upload-trigger");
    const trigger2 = root.querySelector("#ai-upload-trigger-2");

    const hasUser1 = userHidden1 && userHidden1.value.trim() !== "";
    const hasUser2 = coupleMode
      ? userHidden2 && userHidden2.value.trim() !== ""
      : true;

    if (trigger1) trigger1.classList.remove("validation-error");
    if (trigger2) trigger2.classList.remove("validation-error");

    if (!hasAi || !hasUser1) {
      if (trigger1) trigger1.classList.add("validation-error");
      root
        .querySelector('.ai-upload-container[data-upload-index="1"]')
        ?.scrollIntoView({ behavior: "smooth", block: "center" });
      return false;
    }

    if (coupleMode && !hasUser2) {
      if (trigger2) trigger2.classList.add("validation-error");
      root
        .querySelector('.ai-upload-container[data-upload-index="2"]')
        ?.scrollIntoView({ behavior: "smooth", block: "center" });
      return false;
    }

    return true;
  }

  function patchFormValidation(root, form) {
    if (!form || form.dataset.aiUploadPatched === "true") return;

    form.dataset.aiUploadPatched = "true";
    const originalCheckValidity = form.checkValidity.bind(form);

    form.checkValidity = function () {
      if (!originalCheckValidity()) return false;
      return validateSection(root);
    };
  }

  function interceptPaymentButton(root, form) {
    if (!form || form.dataset.paymentObserverAdded === "true") return;

    form.dataset.paymentObserverAdded = "true";

    function validateImages() {
      return validateSection(root);
    }

    const paymentButtonContainer = form.querySelector(".shopify-payment-button");
    if (paymentButtonContainer) {
      paymentButtonContainer.addEventListener(
        "click",
        function (e) {
          if (!validateImages()) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            return false;
          }
        },
        true
      );
    }

    form.addEventListener(
      "submit",
      function (e) {
        const clickedButton = e.submitter;
        if (clickedButton && !clickedButton.id?.includes("AddToCart")) {
          if (!validateImages()) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            return false;
          }
        }
      },
      true
    );

    const addToCartButtons = form.querySelectorAll(
      'button[type="submit"], button[name="add"]'
    );
    addToCartButtons.forEach((button) => {
      if (button.dataset.validationListenerAdded === "true") return;
      button.dataset.validationListenerAdded = "true";
      button.addEventListener(
        "click",
        function (e) {
          if (!validateImages()) {
            e.preventDefault();
            e.stopImmediatePropagation();
            return false;
          }
        },
        true
      );
    });
  }

  function setupVariantCarouselSync(root) {
    if (root.dataset.variantCarouselSync === "true") return;
    root.dataset.variantCarouselSync = "true";

    document.addEventListener("variant:update", (event) => {
      const variant = event.detail?.resource;
      if (!variant?.id) return;

      const productId = root.dataset.productId;
      const eventProductId = event.detail?.data?.productId;
      if (productId && eventProductId && String(eventProductId) !== String(productId)) {
        return;
      }

      const source = event.detail?.data?.source;
      const html = event.detail?.data?.html;
      if (source === "json" || !html) return;

      scheduleCarouselResyncAfterVariant(root);
    });
  }

  function setupVariantListener(root, form, metafields) {
    if (root.dataset.variantListener === "true") return;
    root.dataset.variantListener = "true";

    function applyVariant(variantId) {
      if (!variantId) return;
      toggleSecondUploader(
        root,
        variantNeedsDualUpload(String(variantId), metafields)
      );
    }

    const variantInput = form?.querySelector('input[name="id"]');
    if (variantInput?.value) {
      applyVariant(variantInput.value);
    }

    if (variantInput) {
      variantInput.addEventListener("change", () =>
        applyVariant(variantInput.value)
      );

      let lastVariantId = variantInput.value;
      setInterval(() => {
        if (variantInput.value !== lastVariantId) {
          lastVariantId = variantInput.value;
          applyVariant(lastVariantId);
        }
      }, 400);
    }

    document.addEventListener("variant:update", (event) => {
      const variant = event.detail?.resource;
      if (!variant?.id) return;

      const productId = root.dataset.productId;
      const eventProductId = event.detail?.data?.productId;
      if (productId && eventProductId && String(eventProductId) !== String(productId)) {
        return;
      }

      applyVariant(String(variant.id));
    });

    setupVariantCarouselSync(root);
  }

  function initSection(root) {
    if (!root || root.dataset.aiUploadInitialized === "true") return;
    root.dataset.aiUploadInitialized = "true";

    bindHistoryTrigger(root);

    const form = getFormForRoot(root);
    patchFormValidation(root, form);
    interceptPaymentButton(root, form);

    if (isPropertiesOnlyMode(root)) {
      const uploader = createPropertiesOnlyUploader(root);
      root._aiUploaders = { 1: uploader, 2: null };
      setupVariantCarouselSync(root);
      return;
    }

    const metafields = getVariantMetafields(root);
    const initialCouple = root.dataset.initialCouple === "true";
    toggleSecondUploader(root, initialCouple);

    const uploader1 = createUploader(root, 1);
    const uploader2 = root.querySelector("#ai-upload-trigger-2")
      ? createUploader(root, 2)
      : null;
    root._aiUploaders = { 1: uploader1, 2: uploader2 };

    setupVariantListener(root, form, metafields);

    if (form) {
      const variantInput = form.querySelector('input[name="id"]');
      if (variantInput?.value) {
        toggleSecondUploader(
          root,
          variantNeedsDualUpload(variantInput.value, metafields)
        );
      }
    }
  }

  function initAll() {
    document.querySelectorAll(SECTION_SELECTORS).forEach(initSection);
  }

  function setupQuickAddGuard() {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type !== "attributes") return;

        const target = mutation.target;
        if (target.tagName !== "DIALOG") return;

        const quickAdd = target.closest("quick-add-dialog");
        if (!quickAdd) return;

        const isOpen = target.hasAttribute("open");
        const uploadInProgress = quickAdd.dataset.aiUploadInProgress;
        const modalOpen = quickAdd.dataset.modalOpen;

        if (!isOpen && (modalOpen === "true" || uploadInProgress === "true")) {
          setTimeout(() => target.setAttribute("open", ""), 0);
        }
      });
    });

    document.querySelectorAll("quick-add-dialog dialog").forEach((dialog) => {
      observer.observe(dialog, { attributes: true, attributeFilter: ["open"] });
    });

    new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType !== 1) return;
          node.querySelectorAll?.("quick-add-dialog dialog").forEach((dialog) => {
            observer.observe(dialog, {
              attributes: true,
              attributeFilter: ["open"],
            });
          });
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  function pollQuickAdd() {
    setInterval(() => {
      document.querySelectorAll("quick-add-dialog").forEach((dialog) => {
        const uploadSection = dialog.querySelector(SECTION_SELECTORS);
        if (
          uploadSection &&
          uploadSection.dataset.aiUploadInitialized !== "true"
        ) {
          initSection(uploadSection);
        }
      });
    }, 500);
  }

  waitForDeps(() => {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", initAll);
    } else {
      initAll();
    }

    document.addEventListener("shopify:section:load", initAll);
    setupQuickAddGuard();
    pollQuickAdd();
  });

  window.AiUpload = {
    initAll,
    initSection,
    validateSection,
  };
})();
